export default __webpack_public_path__ + "static/media/gothenburg_l1.91583583.png";